import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { Building2, MapPin, Landmark, Waves } from "lucide-react";

const KomikGdansk = () => (
  <SeoPageLayout title="Komik i stand-up" titleAccent="Gdańsk">
    <SeoSection title="Występy komediowe w Gdańsku">
      <p>Gdańsk, Sopot i Gdynia tworzą Trójmiasto - jeden z najdynamiczniej rozwijających się regionów biznesowych w Polsce. Oferujemy profesjonalne występy komediowe na terenie całego Trójmiasta i Pomorza. Nasi komicy doskonale sprawdzają się zarówno na kameralnych spotkaniach w restauracjach Gdańska, jak i na dużych eventach w sopockich hotelach czy gdyńskich centrach konferencyjnych.</p>
    </SeoSection>

    <SeoSection title="Eventy firmowe w Trójmieście">
      <p>Trójmiasto to silny ośrodek branży IT, logistycznej, morskiej i finansowej. Firmy z tego regionu cenią kreatywne podejście do eventów firmowych. Stand-up komediowy idealnie wpisuje się w nadmorski klimat spotkań integracyjnych, konferencji branżowych i wieczorów bankietowych z widokiem na Zatokę Gdańską.</p>
    </SeoSection>

    <SeoSection title="Popularne lokalizacje eventowe w Trójmieście">
      <SeoFeatureGrid features={[
        { icon: Building2, title: "Sopot", description: "Grand Hotel, Sheraton, Sofitel - luksus nad morzem" },
        { icon: Landmark, title: "Gdańsk", description: "Filharmonia Bałtycka, AmberExpo, ECS" },
        { icon: Waves, title: "Gdynia", description: "Muzeum Emigracji, Sea Towers, hotele przy marinie" },
        { icon: MapPin, title: "Stare Miasto", description: "Kamienice Głównego Miasta, Wyspa Spichrzów" },
      ]} />
    </SeoSection>

    <SeoSection title="Zamów komika w Trójmieście">
      <p>Planujesz event firmowy w Gdańsku, Sopocie lub Gdyni? Skontaktuj się z nami - zaproponujemy format występu idealnie dopasowany do charakteru Twojego wydarzenia i lokalizacji nad morzem.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikGdansk;
